import { Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { CoinReward, ProductReward, Reward } from 'src/app/api/api-campaigns.service.generated';
import { ProductInfo, RewardsProductApiClient } from 'src/app/api/api-rewards.service.generated';

@Component({
  selector: 'app-reward-strategy-edit',
  templateUrl: './reward-strategy-edit.component.html',
  styleUrls: ['./reward-strategy-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    FormsModule
  ]
})
export class RewardStrategyEditComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private rewardProductsApi = inject(RewardsProductApiClient);


  @Input() strategy: Reward;

  advertiserId: string;

  coinRewardOptions = [
    new CoinReward({ coins: 10 }),
    new CoinReward({ coins: 20 }),
    new CoinReward({ coins: 50 }),
    new CoinReward({ coins: 100 })
  ];
  rewardProductsOptions: ProductReward[] = [];

  constructor() {

    this.advertiserId = this.route.snapshot.params.advertiserId;
  }

  async ngOnInit() {
    const productInfos = await lastValueFrom(this.rewardProductsApi.getProductsByAdvertiserId(this.advertiserId, false, false));
    this.rewardProductsOptions = productInfos.map((pi: ProductInfo) =>
      new ProductReward({
        productSlug: pi.slug,
        rewardTitle: pi.name,
        rewardDescription: pi.description,
        rewardThumbUrl: pi.photoUrl,
        rewardPhotoUrl: pi.photoUrl
      }));
  }

  compareRewardFn: ((a: CoinReward, b: CoinReward) => boolean) | null = (a: any, b: any) => a && b && a.coins === b.coins;
  compareProductRewardFn: ((a: ProductReward, b: ProductReward) => boolean) | null = (a: ProductReward, b: ProductReward) => a && b && a.productSlug === b.productSlug;


}

